import React from 'react';

import './authorisation.css'


export function Authorisation(props: {}) {
    return (
        <div className="authorisationContainer">
            Authorised by Andrew Blake for The Greens NSW, 1/275 Broadway Glebe NSW 2037
        </div>
    )
}